var _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 6,
    fill: "#FDCE00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.298 5.118l1.18-1.51a.92.92 0 00.112-.951L8.698.717a.92.92 0 00-1.67.768l.657 1.431-.836 1.07a.92.92 0 001.45 1.133z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.383C3.688 3.257 7.318 4.02 7.318 4.02a.92.92 0 00.347-1.806s-5.415-.98-6.462 3.774A.92.92 0 003 6.383z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 14,
    r: 6,
    fill: "#1E9FD6"
  })));
}
export default __webpack_public_path__ + "fonts/color-swap-54808d64bbc190d6e15ba160a1d7123c.svg";
export { SvgColorSwap as ReactComponent };